'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: translate3d(0, 0, 0);\n    }\n\n    to {\n      visibility: hidden;\n      transform: translate3d(100%, 0, 0);\n    }\n'], ['\n  from {\n      transform: translate3d(0, 0, 0);\n    }\n\n    to {\n      visibility: hidden;\n      transform: translate3d(100%, 0, 0);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = require('../BaseAnimation');

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideOutRightAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideOutRight = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideOutRightAnimation);

exports.default = SlideOutRight;


//////////////////
// WEBPACK FOOTER
// ./~/animate-css-styled-components/lib/Slide/OutRight.js
// module id = 551
// module chunks = 95715928098905 168707334958949